var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandageAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1795 2C20.7372 2 22 3.26279 22 4.82051V5.07667C21.926 5.07671 21.8507 5.08753 21.7761 5.1102L10.2051 8.63182V4.82051C10.2051 3.26279 11.4679 2 13.0256 2H19.1795ZM10.2051 11.8131V12.2564H9.79249L14.7321 21.6417C14.7924 21.7562 14.8209 21.879 14.8208 22H22V16.8719C21.8975 16.872 21.7934 16.8514 21.6934 16.808L10.2051 11.8131ZM7.64126 12.2564H8.15381C8.15371 12.3774 8.18223 12.5001 8.24249 12.6146L13.1822 22H6.8718C6.60232 22 6.33796 21.9781 6.08039 21.936L7.63124 12.3794C7.63794 12.3381 7.64121 12.297 7.64126 12.2564ZM6.08233 12.3201C3.76714 12.6973 2 14.7064 2 17.1282C2 19.0002 3.05585 20.6256 4.60452 21.4414L6.08233 12.3201ZM22 15.2637V6.65021L10.4292 10.1718C10.3605 10.1927 10.2912 10.2035 10.2228 10.2051C10.3196 10.2072 10.4176 10.2279 10.512 10.2689L22 15.2637Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandageAlt);
export default __webpack_public_path__ + "static/media/bandage-alt.9e452b67c6b76a734887b91c25075e5b.svg";
export { ForwardRef as ReactComponent };